export default class Cappy {
    static onlyFirst(str) {
        return str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);
    }
}



// WEBPACK FOOTER //
// ./src/Etc/Cappy.js